import { render } from "./MessageScreen.vue?vue&type=template&id=4179f449"
import script from "./MessageScreen.vue?vue&type=script&lang=js"
export * from "./MessageScreen.vue?vue&type=script&lang=js"

import "./MessageScreen.vue?vue&type=style&index=0&id=4179f449&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__